import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col bg-white gap-3" }
const _hoisted_2 = { class: "w-full my-6 px-6" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "font-semibold text-xl text-gray-900" }
const _hoisted_5 = { class: "flex flex-col gap-2" }
const _hoisted_6 = { class: "suffix-icons flex items-center justify-center absolute top-[0.90rem] right-[0.7rem] gap-8" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h5", { class: "font-semibold text-md text-[#101828] mt-1" }, "Subjects & Classes", -1)
const _hoisted_9 = { class: "flex justify-between items-center" }
const _hoisted_10 = { class: "w-1/2" }
const _hoisted_11 = { class: "w-1/2" }
const _hoisted_12 = { class: "flex gap-4" }
const _hoisted_13 = { class: "w-1/2" }
const _hoisted_14 = { class: "w-1/2" }
const _hoisted_15 = { class: "flex items-center justify-between gap-2 w-full pt-4" }
const _hoisted_16 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_17 = { class: "font-normal pl-1" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "flex flex-col bg-white gap-3" }
const _hoisted_20 = { class: "flex flex-col items-center px-8 py-4" }
const _hoisted_21 = { class: "mt-6 font-semibold text-2xl text-gray-900" }
const _hoisted_22 = { class: "font-normal text-sm text-gray-900 text-center mt-2" }
const _hoisted_23 = { class: "font-bold" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { class: "font-bold" }
const _hoisted_26 = { class: "mt-8 flex gap-4 text-base w-full" }

import { computed, ref } from "vue";
import { useLearnerStore } from "@/stores/learnerStore";
import { FormKitNode } from "@formkit/core";
import showPasswordIcon from "@/assets/auth-module/show-password.svg";
import hidePasswordIcon from "@/assets/auth-module/hide-password.svg";
import { useSchoolStore } from "@/stores/schoolStore";
import { useFilterStore } from "@/stores/filterStore";
import { XCircleIcon } from "@heroicons/vue/20/solid";
import { SubjectFilterOption } from "@/interfaces/filters.interface";
import { watch } from "vue";
import { NewLearner } from "@/interfaces/new-learner.interface";

// Interface for a new learner object
interface NewLearnerData {
  lastName: string;
  firstName: string;
  email: string;
  studentNumber: string | "";
  password: string;
  grade: string | number;
  subjects: {
    maths: boolean;
    english: boolean;
  };
  mathsClass: string;
  englishClass: string;
  schoolId: string | null;
  maths?: boolean;
  english?: boolean;
}

// Props for the component

export default /*#__PURE__*/_defineComponent({
  __name: 'AddLearnerModalComponent',
  props: {
  className: {
    type: String,
    required: true,
  },
  classId: {
    type: String,
    required: true,
  },
},
  emits: ["hideModel"],
  setup(__props, { emit }) {

const props = __props;



// Stores for managing state
const learnerStore = useLearnerStore();
const schoolStore = useSchoolStore();
const filterStore = useFilterStore();

// Reactive variables
const addedLearnerResults = ref(false);
const updateSingleLearner = ref(true);
const passwordVisible = ref(false);

const newLearner = ref<NewLearnerData>({
  lastName: "",
  firstName: "",
  email: "",
  studentNumber: "",
  password: "",
  grade: filterStore.selectedFilters.gradeLevel || 6,
  schoolId: filterStore.selectedFilters.school || null,
  subjects: {
    maths: false,
    english: false,
  },
  mathsClass: "",
  englishClass: ""
});

// Emit event setup


// Function to toggle password visibility
const togglePasswordVisibility = (value: string) => {
  if (value == "password") {
    passwordVisible.value = !passwordVisible.value;
  }
};

// Generate email for the new learner
const generateEmail = () => {
  const email = `${newLearner.value.firstName.toLowerCase()}.${newLearner.value.lastName.toLowerCase()}@${
    schoolStore.getCurrentSchool?.domain
  }`;
  newLearner.value.email = email;
};

// Generate password for the new learner
const generatePassword = () => {
  const password = newLearner.value.firstName.slice(0, 3) + "123";
  newLearner.value.password = password.toLowerCase();
};

// Get current subject
const getCurrentSubject = computed(() => {
  const subject = filterStore.selectedFilters.subject;
  const subjectName = filterStore.filterOptions?.subjects.find(
    (item: SubjectFilterOption) => item._id === subject
  );
  return subjectName?.name;
});

// Function to handle the creation of a new learner
const onCreateLearner = async (value: NewLearnerData) => {
  // Get country from store
  // const getCountry = schoolStore.getCurrentSchool?.location.country;
};

// Computed property to get the password icon
const getPasswordIcon = computed(() => {
  return passwordVisible.value ? showPasswordIcon : hidePasswordIcon;
});

// Function to close the modal
const closeModal = () => {
  updateSingleLearner.value = false;
  emit("hideModel");
};

// Function to handle confirmation of learner addition and reset the form
const handleConfirmLearner = () => {
  emit("hideModel");
  addedLearnerResults.value = false;

  // Clear the form after learner is added
  newLearner.value = {
    lastName: "",
    firstName: "",
    email: "",
    studentNumber: "",
    password: "",
    grade: filterStore.selectedFilters.gradeLevel || 6,
    schoolId: filterStore.selectedFilters.school || null,
    subjects: {
      maths: false,
      english: false,
    },
    mathsClass: "",
    englishClass: ""
  };
};

// Function to validate if an email already exists using the learner store
const email_exists = async (node: FormKitNode): Promise<boolean> => {
  try {
    const emailExists = await learnerStore.validateEmail(node.value as string);
    return !emailExists;
  } catch (error) {
    return true;
  }
};

const mathsClasses = computed(() => {
  const currentGrade = filterStore.selectedFilters.gradeLevel;
  const classes = filterStore.selectedSchoolClasses
    .filter(
      (classGroup) =>
        classGroup.gradeLevel === currentGrade &&
        classGroup.subject === getSubjectIdFromName("Maths")
    )
    .map((classGroup) => ({
      value: classGroup._id,
      label: classGroup.name,
    }));
  return [{ value: "", label: "Select Class" }, ...classes];
});

const englishClasses = computed(() => {
  const currentGrade = filterStore.selectedFilters.gradeLevel;
  const classes = filterStore.selectedSchoolClasses
    .filter(
      (classGroup) =>
        classGroup.gradeLevel === currentGrade &&
        classGroup.subject === getSubjectIdFromName("English")
    )
    .map((classGroup) => ({
      value: classGroup._id,
      label: classGroup.name,
    }));
  return [{ value: "", label: "Select Class" }, ...classes];
});

const getSubjectName = computed(() => {
  const currentSubject = filterStore.selectedFilters.subject;
  const subjectName = filterStore.filterOptions?.subjects.find(
    (item: any) => item._id === currentSubject
  );
  return subjectName?.name;
});

const getSubjectIdFromName = (subjectName: string) => {
  const subject = filterStore.filterOptions?.subjects.find(
    (item: any) => item.name === subjectName
  );
  return subject?._id;
};

//set subject and class defaults
watch(
  () => props.classId,
  (newClassId) => {
    const currentSubject = getSubjectName.value;
    if (currentSubject === "Maths") {
      newLearner.value.subjects.maths = true;
      newLearner.value.mathsClass = newClassId;
    }
    if (currentSubject === "English") {
      newLearner.value.subjects.english = true;
      newLearner.value.englishClass = newClassId;
    }
  },
  { immediate: true }
);

//if the grade changes
watch(
  () => filterStore.selectedFilters.gradeLevel,
  (newGrade) => {
    newLearner.value.grade = newGrade;
  },
  { immediate: true }
);

//if the school changes
watch(
  () => filterStore.selectedFilters.school,
  (schoolId) => {
    newLearner.value.schoolId = schoolId;
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_modal = _resolveComponent("modal")!
  const _component_rl_icon = _resolveComponent("rl-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-lg px-4 py-6 rounded-lg',
      open: updateSingleLearner.value,
      onLocalModalOpen: _cache[8] || (_cache[8] = ($event: any) => (updateSingleLearner.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("student_table_view.add_student")), 1)
            ]),
            _createVNode(_component_FormKit, {
              type: "form",
              modelValue: newLearner.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((newLearner).value = $event)),
              actions: false,
              id: "new-learner-form",
              onSubmit: onCreateLearner
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_FormKit, {
                    type: "text",
                    label: _ctx.$t('student_table_view.table.first_name'),
                    id: "firstName",
                    name: "firstName",
                    "outer-class": "input-thin",
                    placeholder: 
                _ctx.$t('student_table_view.table.first_name_example')
              ,
                    validation: "required",
                    classes: {
                outer: 'col-span-2',
              }
                  }, null, 8, ["label", "placeholder"]),
                  _createVNode(_component_FormKit, {
                    type: "text",
                    label: _ctx.$t('student_table_view.table.last_name'),
                    id: "lastName",
                    name: "lastName",
                    "outer-class": "input-thin",
                    placeholder: 
                _ctx.$t('student_table_view.table.last_name_example')
              ,
                    validation: "required",
                    suffixIcon: false,
                    classes: {
                outer: 'col-span-2',
              }
                  }, null, 8, ["label", "placeholder"]),
                  _createVNode(_component_FormKit, {
                    type: "text",
                    name: "studentNumber",
                    label: _ctx.$t('student_table_view.table.student_number'),
                    "outer-class": "input-thin",
                    placeholder: "1123",
                    classes: {
                outer: 'col-span-2',
              }
                  }, null, 8, ["label"]),
                  _createVNode(_component_FormKit, {
                    type: "email",
                    name: "email",
                    id: "email",
                    label: _ctx.$t('student_table_view.table.email'),
                    "outer-class": "input-thin",
                    placeholder: 
                _ctx.$t('student_table_view.table.email_example', {
                  char: '@',
                })
              ,
                    validation: "required|(500)email_exists",
                    "validation-rules": { email_exists: email_exists },
                    "validation-messages": {
                email_exists: _ctx.$t(
                  'bulk_learner_upload_component.preview_learners.email_validation'
                ),
              },
                    classes: {
                outer: 'col-span-3',
                input: 'mr-[5rem]',
              }
                  }, {
                    suffix: _withCtx(() => [
                      _createElementVNode("h3", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (generateEmail())),
                        class: _normalizeClass(
                    'text-slate-600 font-semibold text-xs cursor-pointer absolute  right-5 top-1/2 -translate-y-1/2'
                  )
                      }, _toDisplayString(_ctx.$t("student_table_view.generate")), 1)
                    ]),
                    _: 1
                  }, 8, ["label", "placeholder", "validation-rules", "validation-messages"]),
                  _createVNode(_component_FormKit, {
                    type: passwordVisible.value ? 'text' : 'password',
                    name: "password",
                    label: _ctx.$t('student_table_view.table.password'),
                    "outer-class": "input-thin",
                    placeholder: 
                _ctx.$t('student_table_view.table.password_example')
              ,
                    validation: "required",
                    classes: {
                outer: 'col-span-3',
              }
                  }, {
                    suffix: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("img", {
                          src: getPasswordIcon.value,
                          alt: "First Suffix Icon",
                          class: "suffix-icon cursor-pointer mr-[4.5rem]",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (togglePasswordVisibility('password')))
                        }, null, 8, _hoisted_7),
                        _createElementVNode("h3", {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (generatePassword())),
                          class: "text-slate-600 font-semibold text-xs cursor-pointer absolute mt-1 right-2"
                        }, _toDisplayString(_ctx.$t("student_table_view.generate")), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["type", "label", "placeholder"]),
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_FormKit, {
                        type: "checkbox",
                        name: "maths",
                        label: "Maths",
                        "outer-class": "flex items-center gap-2 text-[#344054]",
                        modelValue: newLearner.value.subjects.maths,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newLearner.value.subjects.maths) = $event)),
                        config: {
                    classes: {
                      input: 'form-checkbox h-6 w-6 text-blue-600 bg-gray-100 border-gray-300 rounded-md focus:ring-blue-500 focus:ring-2',
                      label: 'text-md pl-2 leading-none',
                    },
                  }
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_FormKit, {
                        type: "checkbox",
                        name: "english",
                        label: "English",
                        "outer-class": "flex items-center gap-2 ml-2 text-[#344054]",
                        modelValue: newLearner.value.subjects.english,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newLearner.value.subjects.english) = $event)),
                        config: {
                    classes: {
                      input: 'form-checkbox h-6 w-6 text-blue-600 bg-gray-100 border-gray-300 rounded-md focus:ring-blue-500 focus:ring-2',
                      label: 'text-md pl-2 leading-none',
                    },
                  }
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      (newLearner.value.subjects.maths)
                        ? (_openBlock(), _createBlock(_component_FormKit, {
                            key: 0,
                            type: "select",
                            name: "mathsClass",
                            label: "Maths Class",
                            "label-class": "text-[#344054]",
                            "outer-class": "w-full",
                            modelValue: newLearner.value.mathsClass,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newLearner.value.mathsClass) = $event)),
                            options: mathsClasses.value,
                            validation: "required"
                          }, null, 8, ["modelValue", "options"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      (newLearner.value.subjects.english)
                        ? (_openBlock(), _createBlock(_component_FormKit, {
                            key: 0,
                            type: "select",
                            name: "englishClass",
                            label: "English Class",
                            "label-class": "text-[#344054]",
                            "outer-class": "w-full",
                            modelValue: newLearner.value.englishClass,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((newLearner.value.englishClass) = $event)),
                            options: englishClasses.value,
                            validation: "required"
                          }, null, 8, ["modelValue", "options"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: closeModal,
                    class: "w-1/2 justify-center font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-4 font-medium flex items-center bg-transparent shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] text-center bg-white"
                  }, _toDisplayString(_ctx.$t("student_table_view.btn_cancel")), 1),
                  _createVNode(_component_FormKit, {
                    type: "submit",
                    "outer-class": 'w-1/2 bg-blue-600 text-white py-[0.11rem] rounded-lg flex items-center justify-center cursor-pointer'
                  }, {
                    default: _withCtx(() => [
                      (_unref(learnerStore).loader.learner)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                            _createVNode(_component_spinner_loader, { color: 'text-white text dark:text-white' }),
                            _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(learnerStore).loadingMessage), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t("student_table_view.btn_submit")), 1))
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-lg px-4 py-6 rounded-lg',
      open: addedLearnerResults.value,
      onLocalModalOpen: _cache[9] || (_cache[9] = ($event: any) => (addedLearnerResults.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", null, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-green-tick',
                title: 'rl green tick',
                "aria-hidden": "true"
              })
            ]),
            _createElementVNode("h1", _hoisted_21, _toDisplayString(_ctx.$t("student_table_view.confirm_modal.title")), 1),
            _createElementVNode("p", _hoisted_22, [
              _createElementVNode("span", _hoisted_23, _toDisplayString(newLearner.value.firstName) + " " + _toDisplayString(newLearner.value.lastName), 1),
              _createElementVNode("span", {
                innerHTML: _ctx.$t('student_table_view.confirm_modal.to')
              }, null, 8, _hoisted_24),
              _createElementVNode("span", _hoisted_25, _toDisplayString(__props.className), 1)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-2 w-full focus:outline-none",
                onClick: handleConfirmLearner
              }, _toDisplayString(_ctx.$t("student_table_view.confirm_modal.btn_edit")), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})